//@@ Libs
import { useContext, useEffect } from 'react'
import { Col, Label, Row, Spinner } from 'reactstrap'

//@@ Utils
import { getOptionsFromRawValues } from '@utils'

//@@ Context
import { FormContext } from '@src/views/apps/reports/features/WebInsights/formContext'

//@@ Components
import UILoader from '@components/ui-loader'
import { FormForTheseSelect } from '@src/views/apps/reports/components/FormElements/FormForTheseSelect'
import { Characteristic } from '@src/views/apps/reports/components/Characteristic/Characteristic'
import { FormSourceActions } from '@src/views/apps/reports/components/FormElements/FormSourceActions'
import { FormBetweenRange } from '@src/views/apps/reports/components/FormElements/FormBetweenRange'

export const FunnelForm = () => {
  //@@ Import form settings context
  const {
    isLoading,
    settings,
    settingsDictionaries,
    onChangeSource,
    onChangeAction,
    onChangeProperties,
    onSettingChange,
    onCharacteristicChange,
    onCharacteristicAdd,
    onCharacteristicValueChange,
    onCharacteristicRemove
  } = useContext(FormContext)

  //@@ Select default Web Metrics source
  useEffect(() => {
    const metricOption = settingsDictionaries.sourcesDictionary.find(({ value }) => value === 'Web Metrics')
    onChangeSource(metricOption, 'start')
    onChangeSource(metricOption, 'end')
  }, [])

  return (
    <UILoader loader={<Spinner />} blocking={isLoading}>
      <FormSourceActions
        isSourceHidden
        firstLabel="Starting With This"
        lastLabel="With These"
        sourcesDictionary={settingsDictionaries.sourcesDictionary}
        actionDictionary={settingsDictionaries.startSourceActionDictionary}
        propertiesDictionary={settingsDictionaries.startSourcePropertiesDictionary}
        action={settings.startSource.action}
        source={settings.startSource.source}
        properties={settings.startSource.properties}
        onChangeSource={(opt) => onChangeSource(opt, 'start')}
        onChangeAction={(opt) => onChangeAction(opt, 'start')}
        onChangeProperties={(opt) => onChangeProperties(opt, 'start')}
      />

      <FormSourceActions
        isSourceHidden
        firstLabel="That Leads To This"
        lastLabel="With These"
        sourcesDictionary={settingsDictionaries.sourcesDictionary}
        actionDictionary={settingsDictionaries.endSourceActionDictionary}
        propertiesDictionary={settingsDictionaries.endSourcePropertiesDictionary}
        action={settings.endSource.action}
        source={settings.endSource.source}
        properties={settings.endSource.properties}
        onChangeSource={(opt) => onChangeSource(opt, 'end')}
        onChangeAction={(opt) => onChangeAction(opt, 'end')}
        onChangeProperties={(opt) => onChangeProperties(opt, 'end')}
      />

      <Row className="mb-2">
        <Col xs={12} sm={6}>
          <FormBetweenRange
            fullWidth
            label="That Happened Between"
            settingDates={settings.betweenDates}
            onSettingChange={onSettingChange}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12} sm={6}>
          <FormForTheseSelect
            label="To These"
            categoriesOptions={settingsDictionaries.membership}
            categoriesValue={getOptionsFromRawValues({
              rawValue: settings.membership,
              options: settingsDictionaries.membership
            })}
            individual={settings.individual}
            onSettingChange={onSettingChange}
          />
        </Col>

        <Col xs={12} sm={6}>
          <Row className="mb-1">
            <Label xs="4" for="withThese" className="pt-0 align-self-start fs-6">
              With These
            </Label>
            <Characteristic
              characteristics={settings.characteristics}
              settingsDictionaries={settingsDictionaries}
              onCharacteristicChange={onCharacteristicChange}
              onCharacteristicAdd={onCharacteristicAdd}
              onCharacteristicValueChange={onCharacteristicValueChange}
              onCharacteristicRemove={onCharacteristicRemove}
            />
          </Row>
        </Col>
      </Row>
    </UILoader>
  )
}
